import React, { useEffect, useRef, useState } from "react";
import { onDeleteWall } from "./utils"; 
import { DELETE_EXTRA_FEED, DELETE_EXTRA_FEED_WALL, UPDATE_USER_PLAN } from '../../../../../actions/api';
import { TOAST_SUCCESS, getInitialRoute } from "../../../../../utils";
import { Accordion } from "react-bootstrap";
import AccordionItemSection from "./AccordionItemSection";
import RevokeModal from "./RevokeModal";
import NetworkIconsSection from "./NetworkIconsSection";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../../../../actions/loginActions";
import $ from 'jquery'
import HttpClient from "../../../../../actions/http-client";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

function WallFeed({ feedsList, deleteWall, deleteFeedFromWall, isFreePlan, setShow, show, loading }) {
  const [activePanelIndex, setActivePanelIndex] = useState(0);
  const { userData } = useSelector(state => state.authenticated, shallowEqual);
  const userRule = userData && Object.keys(userData).length > 0 ? userData.UserRule : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myRef = useRef()

  const deleteExtraFeed = (wallId, feedsList) => {
    new HttpClient().post(DELETE_EXTRA_FEED, { "feedId": feedsList, 
    adminId: localStorage.getItem('Isadmin') || '',
    "isCollaborator": 0, type: getInitialRoute() != 'widget' ? 4 : 6 }).then((response) => {
      if (response.data && Object.keys(response.data).length > 0) {
        const { responseMessage } = response.data;
        TOAST_SUCCESS(responseMessage);
        deleteFeedFromWall(wallId, feedsList);
      }
    }).catch((ex) => {

    });
  }

  const deleteExtraFeedWall = (wallID) => {
    new HttpClient().post(DELETE_EXTRA_FEED_WALL, { "wallId": `${wallID}`,
    adminId: localStorage.getItem('Isadmin') || '',
    "isCollaborator": 0, type: getInitialRoute() != 'widget' ? 4 : 6 }).then((response) => {
      if (response.data && Object.keys(response.data).length > 0) {
        const { responseMessage } = response.data;
        TOAST_SUCCESS(responseMessage);
        deleteWall(wallID);
      }
    }).catch((ex) => {

    });
  }

  const getTotalExtraFeeds = (list) => {
    return list.reduce((acc, curr) => {
      if (curr.feed.length > 0) {
        acc += curr.feed.length;
      }
      return acc;
    }, 0);
  }


  const updateUserPlan = () => {
    new HttpClient().post(UPDATE_USER_PLAN, { type: getInitialRoute() != 'widget' ? 4 : 6 }).then((response) => {
      const { responseData, responseCode } = response.data;
      if (responseCode === 200 && responseData && Object.keys(responseData).length > 0 && responseData.isPlanupdate == 1) {
        localStorage.removeItem('plan_exceeded');
        setTimeout(() => {
          dispatch(getUserInfo(navigate, false, false, true,()=>navigate(`/walls/home`)));
        }, 1000);
      }
    }).catch(ex => {
      const { data } = ex.response;
    });
  }

  useEffect(() => {
    if (feedsList.length > 0 && (feedsList.length <= userRule.walls) && (getTotalExtraFeeds(feedsList) <= userRule.feeds) && isFreePlan != 1) {
      localStorage.removeItem('plan_exceeded');
      dispatch(getUserInfo(navigate, true, false, true));
    } else if (feedsList.length === 0) {
      updateUserPlan();
    } else {
      updateUserPlan();
    }
  }, [feedsList])

  return (
    <div id="plan_restrict_new" className="plan_restrict_body">
      <div className="card card-custom card-stretch gutter-b">
        <div className="card-body">
          <div className="card-header mb-3 border-0">
            <div className="row">
              <div className="col-sm-6 col-5">
                <h6 className="font-size-lg mb-0 text-nowrap">{getInitialRoute() != 'widget' ? 'Wall' : 'Widget'}</h6>
              </div>
              <div className="col-sm-2 col-1">
                <h6 className="text-center font-size-lg mb-0 text-nowrap">Feeds</h6>
              </div>
              <div className="col-sm-2 col-5">
                <h6 className="text-center font-size-lg mb-0 text-nowrap">Network</h6>
              </div>
              <div className="col-sm-2 col-1">
                <h6 className="text-right font-size-lg mb-0 text-nowrap">Action</h6>
              </div>
            </div>
          </div>
          {!loading ? <div id="planAccordion">
            <Accordion activeKey={activePanelIndex} onSelect={(i) => setActivePanelIndex(i)} alwaysOpen={false}>
              {feedsList.map((feed, i) => {
                const networkIconList = feed && feed.feed.length > 0 ? feed.feed.map(network => network.Networkicon) : [];
                return (
                  <Accordion.Item eventKey={i} key={feed.wallId} ref={myRef} className={`accordion-${i} mb-3 border-1 rounded-2 overflow-hidden`}>
                    <Accordion.Header>
                      <div className="container-fluid">
                        <div className="row ps-3">
                          <div className="col-sm-6 col-5">
                            <h6 className="font-size-lg my-2">{feed.wallname}</h6>
                          </div>
                          <div className="col-sm-2 col-1">
                            <h6 className="text-center my-2">{feed.feed.length}</h6>
                          </div>
                          <div className="col-sm-2 col-5">
                            {networkIconList.length > 0 ? <NetworkIconsSection networkList={networkIconList} /> : <p className="mb-0 text-center">-</p>}
                          </div>
                          <div className="col-sm-2 col-1 text-right">
                            <button type="button" onClick={() => {
                              setTimeout(() => {
                                $(`.accordion-${i}`).find('.accordion-button').click()
                              }, 10); onDeleteWall(() => deleteExtraFeedWall(feed.wallId))
                            }} className="btn btn-icon btn-sm btn-clean">
                              <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'text-gray-500 fs-6'} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="planfeed-list-body p-0">
                      {feed.feed.length > 0 &&
                        <AccordionItemSection feeds={feed.feed} wallId={feed.wallId} deleteExtraFeed={deleteExtraFeed} />
                      }
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
            <RevokeModal isFreePlan={isFreePlan} show={show} setShow={setShow} />
            <div className="mt-8">
              <p className="plan_restrict_count text-center text-red mb-0">
                You have exceeded your plan's limit. Delete extra{" "}
                <strong>
                  {getInitialRoute() != 'widget' ? 'Wall' : 'Widget'} (<span className="totalWidget">{feedsList.length > 0 ? (feedsList.length - userRule.walls) >= 0 ? feedsList.length - userRule.walls : 0 : 0}</span>)
                </strong>{" "}
                <strong>
                  Feeds (<span className="totalWidget">{feedsList.length > 0 ? (getTotalExtraFeeds(feedsList) - userRule.feeds) >= 0 ? getTotalExtraFeeds(feedsList) - userRule.feeds : 0 : 0}</span>)
                </strong>{" "}
                for a seamless experience.
              </p>
            </div>
          </div> : <div className="text-center py-8">
            <div className="spinner-border text-gradient" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>}
        </div>
      </div>
    </div>
  );
}

export default WallFeed;